import { window } from "./window.js";
import { parseHTML, parseJSON, parseSVG } from "./parse.js";
export const { fetch, Request, Response } = window;
/**
 * @param {RequestInfo | URL} input
 * @throws {ReferenceError}
 */
const fetchText = async (input) => {
    const res = await fetch(input);
    if (!res.ok) {
        console.error("fetch html not ok", res);
        throw ReferenceError();
    }
    return res.text();
};
/**
 * @param {RequestInfo | URL} input
 */
export const fetchHTML = async (input) => parseHTML(await fetchText(input));
/**
 * @param {RequestInfo | URL} input
 */
export const fetchJSON = async (input) => parseJSON(await fetchText(input));
/**
 * @param {RequestInfo | URL} input
 */
export const fetchSVG = async (input) => parseSVG(await fetchText(input));
/**
 * @param {Request | Response} requestOrResponse
 * @param {string} name
 */
export const getHeader = ({ headers }, name) => headers.get(name);
